import React,  { Component } from 'react'


class TimeSpanAdjuster extends Component {

    constructor(props) 
    {
        super(props);
        this.state = {
            checked: props.checked,
            onChange:props.onChange
        };
    }

    componentDidMount() 
    {
        
    }

    renderCheckBox(fieldname, labeltext)
    {
        return(
            <div className="p-1 m-1 hover rounded" key={"key"+fieldname}>
                <input 
                    className=""
                    type="checkbox" 
                    checked={fieldname===this.state.checked} 
                    onChange={()=>{
                        this.setState({
                            checked: fieldname
                        })
                        this.state.onChange(fieldname);
                    }} 
                    id={"htmlid"+fieldname}
                />
                <label 
                    className="m-1" 
                    htmlFor={"htmlid"+fieldname}
                >
                    {labeltext}
                </label>
            </div>
        );
    }

    render()
    {
        return (
            <div className="d-flex justify-content-center m-1 lightblue">
                {this.renderCheckBox("weekly", "Weekly")}
                {this.renderCheckBox("monthly", "Monthly")}
                {this.renderCheckBox("bimonthly", "BiMonthly")}
                {this.renderCheckBox("quarterly", "Quarterly")}
                {this.renderCheckBox("yearly", "Yearly")}
                {this.renderCheckBox("other", "Other")}
            </div>
        );
    }
}


export default TimeSpanAdjuster;
